// import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { WalletProvider } from "@solana/wallet-adapter-react";
import {
  PhantomWalletAdapter,
  SafePalWalletAdapter,
  SolflareWalletAdapter,
  TrustWalletAdapter,
  // WalletConnectWalletAdapter,
} from "@solana/wallet-adapter-wallets";
import { CoinbaseWalletAdapter } from "@solana/wallet-adapter-wallets";
import { coinbaseWallet, safe } from "@wagmi/connectors";
// import { walletConnect } from "@wagmi/connectors";
import { createConfig, createStorage, http, injected } from "@wagmi/core";
import { cookieStorage } from "@wagmi/core";
import { NetworkSymbols } from "based-auth/networks";
import { createContext, useContext, useMemo, useRef, useState } from "react";
import { Chain } from "viem";

interface SimpleKitContextType {
  chains: any[];
  wagmiConfig: any;
  signMessage: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  pendingItem: any;
  setPendingItem: React.Dispatch<React.SetStateAction<any>>;
  router: any;
  setRouter: React.Dispatch<React.SetStateAction<any>>;
}

export const titles = {
  home: "Connect",
  account: "Account",
  walletConnecting: "Wallet Connecting",
  selectETHWallet: "Select ETH Wallet",
  selectSolanaWallet: "Select Solana Wallet",
  walletqr: "Wallet QR",
  switchAccount: "Switch Account",
  switchingAccount: "Switching Account",
  switchChain: "Switch Chain",
  switchingChain: "Switching Chain",
  withdrawFunds: "Withdraw Funds",
  withdrawingFunds: "Withdrawing Funds",
  accountSigning: "Account Signing",
};

export const routes = {
  home: "home",
  account: "account",
  accountSigning: "accountSigning",
  socialConnecting: "socialConnecting",
  walletConnecting: "walletConnecting",
  selectETHWallet: "selectETHWallet",
  selectSolanaWallet: "selectSolanaWallet",
  walletqr: "walletqr",
  switchAccount: "switchAccount",
  switchingAccount: "switchingAccount",
  switchChain: "switchChain",
  switchingChain: "switchingChain",
  withdrawFunds: "withdrawFunds",
  withdrawingFunds: "withdrawingFunds",
};

export const SimpleKitContext = createContext<SimpleKitContextType>({
  chains: [],
  wagmiConfig: null,
  signMessage: "based.bid welcomes you!!!",
  pendingItem: null,
  setPendingItem: () => {},
  open: false,
  setOpen: () => {},
  router: routes.home,
  setRouter: () => {},
});

export const useSimpleKitContext = () => {
  return useContext(SimpleKitContext);
};

export const useSimpleKit = () => {
  const { open, setOpen, ...rest } = useContext(SimpleKitContext);
  return {
    isOpen: open,
    openModal: () => {
      setOpen(true);
    },
    closeModal: () => {
      setOpen(false);
    },
    ...rest,
  };
};

export const SimpleKitContextProvider = ({
  children,
  chains,
  host,
  name,
  description,
  icon,
  projectId,
  signMessage,
}: {
  children: React.ReactNode;
  chains: any[];
  host: string;
  name: string;
  description: string;
  icon: string;
  projectId: string;
  signMessage: string;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const [router, setRouter] = useState<any>(null);
  const [pendingItem, setPendingItem] = useState<any>(null);

  // const walletConnectConnector = useRef(
  //   walletConnect({
  //     projectId,
  //     metadata: {
  //       name,
  //       description,
  //       url: host,
  //       icons: [icon],
  //     },
  //     showQrModal: false,
  //     qrModalOptions: {
  //       themeMode: "dark",
  //     },
  //   })
  // );

  const wagmiConfig = useMemo(() => {
    const filteredChains = chains.filter(
      (item) => item.network.symbol === NetworkSymbols.eth
    );
    const isInIframe =
      !(typeof window === "undefined") && window?.parent !== window;
    return createConfig({
      chains: filteredChains as any,
      connectors: [
        injected({ target: "metaMask" }),
        // walletConnectConnector.current,
        coinbaseWallet({
          appName: name,
          appLogoUrl: icon,
          overrideIsMetaMask: false,
          preference: "all",
        }),
        ...(isInIframe
          ? [
              safe({
                allowedDomains: [/gnosis-safe.io$/, /app.safe.global$/],
              }),
            ]
          : []),
      ],
      storage: createStorage({
        storage: cookieStorage,
      }),
      transports: Object.fromEntries(
        filteredChains.map((chain) => [chain.id, http()])
      ),
    });
  }, [chains]);

  const solWallets = useMemo(
    () => [
      new CoinbaseWalletAdapter(),
      new PhantomWalletAdapter(),
      new SafePalWalletAdapter(),
      new SolflareWalletAdapter(),
      new TrustWalletAdapter(),
      // new WalletConnectWalletAdapter({
      //   network: WalletAdapterNetwork.Mainnet,
      //   options: {
      //     relayUrl: "wss://relay.walletconnect.com",
      //     projectId,
      //     metadata: {
      //       name,
      //       description,
      //       url: host,
      //       icons: [icon],
      //     },
      //   },
      // }),
    ],
    []
  );

  return (
    <SimpleKitContext.Provider
      value={{
        chains,
        wagmiConfig,
        signMessage,
        open,
        setOpen,
        router,
        setRouter,
        pendingItem,
        setPendingItem,
      }}
    >
      <WalletProvider wallets={solWallets} autoConnect>
        {children}
      </WalletProvider>
    </SimpleKitContext.Provider>
  );
};
